import React from 'react';
import { House, ReceiptText, Tag, Coffee, UserRound } from 'lucide-react';

export type NavTabId = 'home' | 'pesanan' | 'promo' | 'outlet' | 'menu' | 'akun';

interface BottomNavProps {
  activeTab: NavTabId;
  onChangeTab: (tab: NavTabId) => void;
}

export const BottomNav: React.FC<BottomNavProps> = ({ activeTab, onChangeTab }) => {
  const navItems: { id: NavTabId; label: string; icon: React.ComponentType<{ className?: string }> }[] = [
    { id: 'home', label: 'Home', icon: House },
    { id: 'pesanan', label: 'Pesanan', icon: ReceiptText },
    { id: 'promo', label: 'Promo', icon: Tag },
    { id: 'menu', label: 'Menu', icon: Coffee },
    { id: 'akun', label: 'Akun', icon: UserRound },
  ];

  return (
    <nav
      id="bottom-nav"
      aria-label="Mobile Bottom Navigation"
      className="font-jakarta fixed bottom-0 left-0 right-0 z-50 lg:hidden bg-white/95 backdrop-blur-xl border-t border-[#E2E8F0] px-4 py-2 pb-[max(0.5rem,env(safe-area-inset-bottom,0px))] shadow-[0_-4px_20px_rgba(0,0,0,0.04)] select-none pointer-events-auto"
    >
      <div className="max-w-lg md:max-w-2xl mx-auto flex justify-between items-center">
        {navItems.map((item) => {
          const isActive = activeTab === item.id;
          const IconComponent = item.icon;

          return (
            <button
              key={item.id}
              type="button"
              onClick={() => onChangeTab(item.id)}
              className={`flex flex-col items-center gap-1 px-3 py-0.5 transition-colors cursor-pointer whitespace-nowrap ${
                isActive ? 'text-[#0056D2]' : 'text-slate-400 hover:text-[#0A192F]'
              }`}
            >
              <IconComponent
                className={`w-5 h-5 ${
                  isActive ? 'text-[#0056D2] stroke-[2.3]' : 'text-slate-400 stroke-[1.9]'
                }`}
              />
              <span
                className={`text-[11px] leading-[14px] ${
                  isActive ? 'font-bold text-[#0056D2]' : 'font-medium text-slate-400'
                }`}
              >
                {item.label}
              </span>
            </button>
          );
        })}
      </div>
    </nav>
  );
};
